import { render } from "./basic.vue?vue&type=template&id=3d3fc775"
const script = {}

import exportComponent from "/Users/romanmatveev/Documents/Dev/html_docs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__